import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseBalance,
  fetchBalance,
  fetchBalanceSuccess,
  fetchBalanceFailed,
} from '../handleReducers';

const {
  REQUEST_API_BALANCE,
  REQUEST_API_BALANCE_SUCCESS,
  REQUEST_API_BALANCE_FAILED,
  REQUEST_CLEAR_BALANCE,
} = types;

const initialState = {
  ...baseBalance(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case REQUEST_API_BALANCE:
      return fetchBalance(actions, state);

    case REQUEST_API_BALANCE_SUCCESS:
      return fetchBalanceSuccess(actions, state);

    case REQUEST_API_BALANCE_FAILED:
      return fetchBalanceFailed(actions, state);

    case REQUEST_CLEAR_BALANCE:
      return baseBalance();

    default:
      return state;
  }
};
